import { Navigate, Outlet } from 'react-router-dom';

import useAuth from './useAuth';
import { PATH_AFTER_LOGIN } from '../config';

// Evita que un usuario ya autenticado vuelva a ver login/registro:
// lo redirige directamente a su area (tienda o panel admin) segun su rol.
export default function GuestGuard() {
  const { isAuthenticated, isInitialized, role } = useAuth();

  if (!isInitialized) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to={PATH_AFTER_LOGIN[role] || '/'} replace />;
  }

  return <Outlet />;
}
